import React, { FC, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import classNames from "classnames/dedupe";
import { useVideo } from "../../Utility";

export interface IYoutubeEmbedProps {
  embedId: string;
  width?: string | number;
  height?: string | number;
  stopVideo?: boolean;
  classes?: {
    root?: string;
    video?: string;
  };
}

const YoutubeEmbed: FC<IYoutubeEmbedProps> = ({
  embedId,
  classes,
  width = "100%",
  height = "100%",
  stopVideo,
}) => {
  const [videoState, player] = useVideo({
    url: `https://www.youtube.com/embed/${embedId}`,
  });

  const [internalPlayer, setInternalPlayer] = useState(null);
  const onPlayerReady = () => {
    setInternalPlayer(player.current.getInternalPlayer());
  };

  useEffect(() => {
    stopVideo && internalPlayer?.pauseVideo();
  }, [stopVideo, internalPlayer]);
  return (
    <div
      data-testid="youtube-video-wrapper"
      className={classNames("youtube-video-wrapper", classes?.root)}
    >
      <ReactPlayer
        ref={player}
        {...videoState}
        className={classNames("youtube-video-player", classes?.video)}
        width={width}
        height={height}
        controls
        onReady={onPlayerReady}
        data-testid="youtube-video-player"
      />
    </div>
  );
};

export default YoutubeEmbed;
